import { IProductOfferListing } from '@models/IProductOfferListing';
import ProductOfferListing from '@molecules/ProductOfferListing/ProductOfferListing';

interface Props {
  readonly productOffers: IProductOfferListing[];
}

const ProductOffersListing = ({ productOffers }: Props) => (
  <section>
    {productOffers.map((productOffer) => (
      <ProductOfferListing key={productOffer.title} {...productOffer} />
    ))}
  </section>
);

export default ProductOffersListing;
